export const MIN_SIDEBAR_WIDTH = 320;
export const MAX_SIDEBAR_WIDTH = 640;
export const DEFAULT_SIDEBAR_WIDTH = 400;

export const OPEN_STORAGE_KEY = 'console_ai_assistant_open';
export const WIDTH_STORAGE_KEY = 'console_ai_assistant_width';
export const ACTIVE_SESSION_STORAGE_KEY = 'console_ai_assistant_active_session';
